<template>
  <v-text-field v-bind="$attrs" v-model="valueLocal">
    <template v-slot:append>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="mt-1" text x-small @click="updateAddress">{{
            address
          }}</v-btn>
        </template>
        Select the cell and click to update the reference
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
const Excel = window.Excel
import { mixinExcel } from '@/mixins/mixin.excel'

export default {
  mixins: [mixinExcel],

  props: {
    value: {
      type: [String],
      default: '',
    },
    address: {
      type: String,
      required: true,
    },
  },

  data() {
    return {}
  },

  computed: {
    valueLocal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    addressLocal: {
      get() {
        return this.address
      },
      set(val) {
        this.$emit('update:address', val)
      },
    },
  },

  watch: {
    addressLocal: {
      immediate: true,
      handler() {
        this.updateValueFromExcel()
      },
    },
    valueLocal: {
      handler() {
        this.updateExcelFromValue()
      },
    },
  },
  mounted() {
    const vue = this
    window.Excel.run(function (context) {
      const sheet = context.workbook.worksheets.getActiveWorksheet()
      sheet.onChanged.add((event) => {
        return context.sync().then(function () {
          if (event.address === vue.addressLocal) {
            vue.updateValueFromExcel()
          }
        })
      })
      return context.sync().then(function () {
        console.log(
          'Event handler successfully registered for onChanged event in the textfield.'
        )
      })
    }).catch((error) => {
      console.error(error)
    })
  },
  methods: {
    updateValueFromExcel() {
      const vue = this
      return Excel.run(async function (context) {
        const sheet = context.workbook.worksheets.getActiveWorksheet()
        const range = sheet.getRange(vue.addressLocal)
        range.load('text')
        await context.sync()
        vue.valueLocal = String(range.text)
      })
    },
    updateExcelFromValue() {
      const vue = this
      Excel.run(async function (context) {
        const sheet = context.workbook.worksheets.getActiveWorksheet()
        const range = sheet.getRange(vue.addressLocal)
        range.values = [[vue.valueLocal]]

        return context.sync()
      })
    },

    updateAddress() {
      console.log('selectedRangeAddress', this.selectedRangeAddress)
      if (this.selectedRangeAddress) {
        this.addressLocal = this.selectedRangeAddress
      }
    },
  },
}
</script>

<style></style>
